import React, { Component } from 'react';
import { Card, AppBar, Tabs, Box, Tab } from '@material-ui/core';
import Notif from '../../../commonModules/interface/Notif';
import { toast } from 'react-toastify';
import { isEmpty } from 'lodash-es';
import JsonFormSchema from '../../../commonModules/interface/JsonFormSchema';


class AddForm extends Component {
    state = {
        forms: [],
        currentForms: null,
        currentIdx: 0,
        info: [],
        headerMenu: 1,
        validated: false,
        notifTitle: '',
        notifMessage: '',
        notifType: '',
    };
    componentWillMount = async() => {
        try {
            const formsId = await fetch('/schema/getCommercialForm', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'same-origin'
            });
            const formsIdBody = await formsId.json();
            console.log('[/schema/getCommercialForm] : ', formsIdBody);

            for (let i = 0; i < formsIdBody.content.forms.length; ++i) {
                let forms = [];
                for (let k = 0; k < formsIdBody.content.forms[i].schema.length; ++k) {
                    const form = await fetch(`/schema/get?idSchema=${formsIdBody.content.forms[i].schema[k]}`, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        credentials: 'same-origin'
                    });
                    const formBody = await form.json();
                    console.log('[/schema/get]: ', formBody);
                    forms = [...forms, {
                        id: formBody.schemaID,
                        schema: JSON.parse(formBody.jsonSchema),
                        uiSchema: JSON.parse(formBody.uiSchema)
                    }]
                }
                this.setState({
                    forms: [
                        ...this.state.forms, {
                            forms: [...forms],
                            schemaIds: formsIdBody.content.forms[i].schema,
                            url: formsIdBody.content.forms[i].url,
                            action: formsIdBody.content.forms[i].action
                        }
                    ],
                })
            }
            console.log("Forms", this.state.forms);
            this.setState({ 
                currentForms: this.state.forms[1], 
                schema: this.state.forms[1].forms[0].schema, 
                uiSchema: this.state.forms[1].forms[0].uiSchema 
            });
        } catch (err) {
            console.log('[ERROR],componentWillMount, Can not Schema ',err);
        }
    }

    submitWithoutPos = async (info, err) => {
        const { currentForms } = this.state;
        console.log('ACTION INFO : ', currentForms, info);
        console.log('ACTION INFO err : ', err);

        const payload = {
            data: info,
            url: currentForms.url,
            schemaID: currentForms.schemaIds,
            action: currentForms.action,
            position: {}
        };
  
        const response = await fetch('/schema/sendForm', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
            credentials: 'same-origin'
        });
        const body = await response.json();
        console.log('WITHOUT POS RES : ', {body});

        if (body.statusCode === 200) {
            this.setState({
                currentIdx: 0,
                info: [],
                schema: currentForms.forms[0].schema,
                uiSchema: currentForms.forms[0].uiSchema,
                validated: true,
                // notifTitle: 'Succès!',
                // notifType: 'success',
                // notifMessage: 'Les informations ont bien été ajoutés.',
            });
            toast.success('Les informations ont bien été ajoutés.')
        } else {
            console.log('[ERROR] submitWithoutPos : ', body.statusCode);
            console.log('====================================');
            console.log({body});
            console.log({INFO: this.state.info});
            console.log('====================================');
            this.setState({
                currentIdx: 0,
                // info: [],
                schema: currentForms.forms[0].schema,
                uiSchema: currentForms.forms[0].uiSchema,
                // ...this.state,
                // validated: true,
                // notifTitle: 'Error!',
                // notifType: 'error',
                // notifMessage: body.content,
            });
            toast.error(body.content)
        }
      }
    submitForm = async () => {
        try {
            const { currentIdx, forms, currentForms, info } = this.state;
            console.log('[INFO] submitForm');
            console.log(info);
            let body;

            if (forms && currentIdx === currentForms.forms.length - 1) {
                let payload = {
                    data: info,
                    url: currentForms.url,
                    action: currentForms.action,
                    schemaID: currentForms.schemaIds,
                    position: {},
                }
                if ('geolocation' in navigator) {
                    navigator.geolocation.getCurrentPosition(() => {}, () => {}, {});
                    // The working next statement.
                    navigator.geolocation.getCurrentPosition(async (position) => {
                        // Your code here
                        console.log('POS IS : ', position);
                        payload.position = {
                            accuracy: position.coords.accuracy,
                            altitude: position.coords.altitude || 0,
                            altitudeAccuracy: position.coords.altitudeAccuracy || 0,
                            heading: position.coords.heading || 0,
                            latitude: position.coords.latitude,
                            longitude: position.coords.longitude,
                            speed: position.coords.speed || 0,
                        };
                        const response = await fetch('/schema/sendForm', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify(payload),
                            credentials: 'same-origin'
                        });
                        body = await response.json();
                        console.log(body);
                        // Error handler below: entering this.submitWithoutPos when location is disable

                        if (body.statusCode === 200) {
                            // console.log('[DEBUG],submitForm, Body Code 200 , Without Position : ', body.statusCode);
                            this.setState({
                                currentIdx: 0,
                                info: [],
                                schema: currentForms.forms[0].schema,
                                uiSchema: currentForms.forms[0].uiSchema,
                                validated: true,
                                // notifTitle: 'Succès!',
                                // notifType: 'success',
                                // notifMessage: 'Les informations ont bien été ajoutés.',
                            });
                            toast.success('Les informations ont bien été ajoutés.')
                            // console.log('[DEBUG],submitForm, Start Time out, Without Position  ');
                        } else {
                            this.setState({
                                currentIdx: 0,
                                // info: [],
                                schema: currentForms.forms[0].schema,
                                uiSchema: currentForms.forms[0].uiSchema,
                                // ...this.state,
                                // validated: true,
                                // notifTitle: 'Error!',
                                // notifType: 'error',
                                // notifMessage: body.content,
                            });
                            toast.error(body.content)

                            // console.log('[DEBUG],submitForm, Start Time out 2, Without Position ');
                        }

                    }, (err) => { 
                        return this.submitWithoutPos(info, err) 
                    }, {
                        enableHighAccuracy: true
                    });
                } else {
                    this.submitWithoutPos(info) 
                }
            } else {
                console.log('[INFO] submitForm Next Schema ',currentIdx);
                this.setState({
                    schema: currentForms.forms[currentIdx + 1].schema,
                    uiSchema: currentForms.forms[currentIdx + 1].uiSchema,
                    currentIdx: currentIdx + 1
                });
            }
        } catch (err) {
            console.log('[ERROR] submitForm Can not find Schema ', err);
        }
    }
    shouldComponentUpdate = (nextProps, nextState) => {
        // console.log('[DEBUG],AddClient,shouldComponentUpdate, Next Init Form Data,',nextProps, ' and ', nextState);
        if (nextProps.schemaID != this.state.schemaID){
            if (nextProps.initFormData != ""){
                this.setState({schemaID: nextProps.schemaID,initFormData: nextProps.initFormData});
            } else {
                this.setState({schemaID: nextProps.schemaID });
            }
            console.log('[INFO], AddClient, shouldComponentUpdate, ok=======+++++');
            return true
        } else {
            if (nextState.forms != this.state.forms){
                console.log('[INFO], AddClient, shouldComponentUpdate, JSON +++++');
                return true;
            }
            if (nextState.currentForms != this.state.currentForms){
                console.log('[INFO], AddClient, shouldComponentUpdate,currentForms, JSON +++++');
                return true;
            }
            if (nextState.info != this.state.info){
                console.log('[INFO], AddClient, shouldComponentUpdate,info, JSON +++++');
                return true;
            }
            if (nextState.loading != this.state.loading){
                console.log('[INFO], AddClient, shouldComponentUpdate,loading, JSON +++++');
                return true;
            }
            if (nextState.currentIdx != this.state.currentIdx){
                console.log('[INFO], AddClient, shouldComponentUpdate,currentIdx, JSON +++++');
                return true;
            }
            if (nextState.schema != this.state.schema){
                console.log('[INFO], AddClient, shouldComponentUpdate,schema, JSON +++++');
                return true;
            }
            if (nextState.uiSchema != this.state.uiSchema){
                console.log('[INFO], AddClient, shouldComponentUpdate,uiSchema, JSON +++++');
                return true;
            }
            return false
        }
    }

    handlePreviousCli() {
        const { currentIdx, forms, currentForms, info } = this.state;

        if (forms && currentIdx !== 0) {
            this.setState({
                schema: currentForms.forms[currentIdx - 1].schema,
                uiSchema: currentForms.forms[currentIdx - 1].uiSchema,
                currentIdx: currentIdx - 1
            });
        }
    }
    handleOnChangeCli({ formData }) {
        this.setState({ formData });
    }
    handleSubmitCli = ({formData}) => {
        let info = [].concat(this.state.info)
        info[this.state.currentIdx] = formData
        this.setState({
            info, 
            loading: true
        }, this.submitForm);
    }

    handleOnChange({ formData }) {
        this.setState({ formData });
    }
    handleSubmit = ({formData}) => {
        
        this.setState({
            info: [formData], 
            // info: [...this.state.info, formData], 
            loading: true
        }, this.submitForm);
    }

    handleChange = (e, newHeader) => {
        const { forms } = this.state;
        console.log('====================================');
        console.log({newHeader});
        console.log('====================================');
        this.setState({ 
            headerMenu: newHeader, 
            currentIdx: 0, 
            currentForms: forms[newHeader], 
            schema: forms[newHeader].forms[0].schema, 
            uiSchema: forms[newHeader].forms[0].uiSchema, 
            info: [] 
        })
    }
    render() {
        const { headerMenu, forms, currentForms, currentIdx } = this.state;
        console.log('[STATE] =============================');
        console.log(this.state);
        console.log('====================================');
        return (
            <div>
                {!currentForms &&
                    <h4 style={{ paddingBottom: '1.5rem', textAlign: 'center' }}>Chargement des formulaires...</h4>
                }
                { currentForms &&
                    <Card>
                        <AppBar position="static">
                            <Tabs
                                value={headerMenu}
                                onChange={this.handleChange}
                                indicatorColor="secondary"
                                // textColor="secondary"
                                variant="fullWidth"
                            >
                                <Tab label="Ajouter un Client" value={1} />
                                <Tab label="Ajouter un Prospect" value={0} />
                            </Tabs>
                        </AppBar>
                        <Box p={2}>
                            { headerMenu == 1 &&
                                <JsonFormSchema
                                    formData={!isEmpty(this.state.info) && this.state.info[currentIdx]}
                                    schema={this.state.schema}
                                    uiSchema={this.state.uiSchema}
                                    onChange={args => this.handleOnChangeCli(args)}
                                    onSubmit={args => this.handleSubmitCli(args)}
                                />

                            }
                            { headerMenu == 0 &&
                                <JsonFormSchema
                                    formData={!isEmpty(this.state.info) && this.state.info[0]}
                                    schema={this.state.schema}
                                    uiSchema={this.state.uiSchema}
                                    onChange={args => this.handleOnChange(args)}
                                    onSubmit={args => this.handleSubmit(args)}
                                />
                            }
                        </Box>
                        {/* { this.state.validated &&
                            <Notif
                                show={this.state.validated}
                                message={this.state.notifMessage}
                                type={this.state.notifType}
                                title={this.state.notifTitle}
                                close={() => this.setState({validated: false})}
                            />
                        } */}
                    </Card>                  
                }
            </div>
        );
    }
}

export default AddForm
